// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'book';

export const Component = () => (
  <path d='M21.637 20.595h.479c.335 0 .479-.144.479-.48V1.486c0-.431-.144-.766-.432-1.054A1.408 1.408 0 0 0 21.11 0H3.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 2 1.485V22.08c0 .67.24 1.245.719 1.724.48.479 1.054.719 1.724.719h17.673c.335 0 .479-.144.479-.479 0-.335-.144-.527-.48-.527h-.478v-2.921Zm-15.71-8.812V.959h5.891v10.824L8.848 9.58l-2.92 2.203Zm14.703 8.812v2.92H4.443a1.41 1.41 0 0 1-1.054-.43c-.287-.24-.431-.576-.431-1.006 0-.43.144-.767.431-1.054a1.408 1.408 0 0 1 1.054-.431H20.63Zm1.007-.958H4.443c-.527 0-1.005.143-1.484.479V1.486c0-.336.191-.527.526-.527h1.437v12.356c0 .144.048.239.191.239h.048c.048-.048.048-.048.096-.048l3.592-2.73 3.64 2.73c.048.048.048.048.096.048.144 0 .192-.096.192-.24V.96h8.333c.335 0 .527.191.527.526v18.152Z' />
);

export const viewBox = '0 0 25 25';
